import React, { useState, useEffect } from 'react'

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { Form, Button, Alert } from 'react-bootstrap'

import imgUnCheck from './images/uncheck.svg';
import imgCheck from './images/check.svg';

// ✅ 1) кеш для geo-запиту (виконається 1 раз на сторінку)
let geoCountryPromise = null;

async function getCountryByIP() {
  try {
    // якщо вже є запит — повертаємо той самий Promise
    if (!geoCountryPromise) {
      geoCountryPromise = fetch('https://ipapi.co/json/')
        .then((r) => r.json())
        .then((data) => {
          // ipapi повертає country_code типу "UA", "DE"...
          const code = (data?.country_code || '').toUpperCase();
          return code || null;
        })
        .catch(() => null);
    }
    return await geoCountryPromise;
  } catch {
    return null;
  }
}

const LeadForm = function ({ setShowLegal }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [userMess, setUserMess] = useState(false);
  const [resStatus, setResStatus] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validPhoneImg, setValidPhoneImg] = useState(null);

  // ✅ 2) країна за замовчуванням для PhoneInput
  const [defaultCountry, setDefaultCountry] = useState("RU");

  // ✅ 3) визначення країни по IP (1 раз завдяки кешу вище)
  useEffect(() => {
    let alive = true;
    (async () => {
      const code = await getCountryByIP();
      if (alive && code) setDefaultCountry(code);
    })();
    return () => { alive = false; };
  }, []);

  const keyUpHandler = () => {
    if (!phone) {
      setValidPhoneImg(null);
      return;
    }

    isValidPhoneNumber(phone) ? setValidPhoneImg(imgCheck) : setValidPhoneImg(imgUnCheck);

    onKeyPressHandler();
  };

  const [typingTimer, setTypingTimer] = useState(null);
  const doneTypingHandler = (e) => {
    const data = { name, phone, message, email };

    fetch('/log.php', {
      method: 'post',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    });
  }

  const onKeyPressHandler = (e) => {
    if (typingTimer) clearTimeout(typingTimer);
    setTypingTimer(setTimeout(doneTypingHandler, 3000));
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (!phone || !name || !message || !email) {
      setResStatus('danger');
      setUserMess('Проверьте правильность заполнение формы и повторите попытку!');
      return;
    }

    if (isValidPhoneNumber(phone)) {
      const data = { name, phone, message, email };
      setIsSubmitting(true);

      fetch('/contact.php', {
        method: 'post',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          setIsSubmitting(false);

          if (response.status === 'success') {
            window.dataLayer?.push({
              event: "form_submission_success",
              formId: "contactForm",
            });
            //window.ym(94206604, 'reachGoal', 'forma');
            setName('');
            setPhone('');
            setMessage('');
            setEmail('');
            setValidPhoneImg(null);            
          }

          if (response.status === 'success' || response.status === 'danger') {
            setResStatus(response.status);
            setUserMess(response.message);
          }
        });
    } else {
      setResStatus('danger');
      setUserMess('Введен некорректный телефон!');
    }
  };

  const nameChangeHandler = (val) => {
    setName(val.target.value);
    onKeyPressHandler();
  }

  return (
    <Form onSubmit={onSubmit}>
      {resStatus ? (<Alert variant={resStatus}>{userMess}</Alert>) : ''}

      <Form.Group controlId="formBasicEmail">
        <Form.Label>Ваше имя</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ваше имя"
          onChange={nameChangeHandler}
          onKeyPress={onKeyPressHandler}
          value={name}
          required
        />
      </Form.Group>

      <Form.Group controlId="formBasicEmail">
        <Form.Label>Ваш email</Form.Label>
        <Form.Control
          type="email"
          placeholder="Ваш email"
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={onKeyPressHandler}
          value={email}
          required
        />
      </Form.Group>

      <Form.Group controlId="formBasicPassword">
        <Form.Label>Ваш телефон</Form.Label>
        <PhoneInput
          placeholder="Enter phone number"
          className="form-control"
          value={phone}
          defaultCountry={defaultCountry}   // ✅ тут підставляємо IP-країну
          international={true}
          onKeyUp={keyUpHandler}
          onKeyPress={onKeyPressHandler}
          onChange={setPhone}
        />
        <img src={validPhoneImg} className="imgCheckPhone" alt="" />
      </Form.Group>

      <Form.Group controlId="formBasicMessage">
        <Form.Label>Ваше сообщение</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Опишите коротко вашу проблему..."
          required
        />
      </Form.Group>

      <Form.Text className="text-muted mt-3 mb-2" style={{ fontSize: "13px" }}>
        Отправляя форму, вы соглашаетесь с{" "}
        <a href="#privacy" onClick={(e) => { e.preventDefault(); setShowLegal(true); }}>
          Политикой конфиденциальности
        </a>{" "}
        и{" "}
        <a href="#terms" onClick={(e) => { e.preventDefault(); setShowLegal(true); }}>
          Пользовательским соглашением
        </a>.
      </Form.Text>

      <Button variant="primary" type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'Отправка...' : 'Получить бесплатную консультацию'}
      </Button>
    </Form>
  );
}

export default LeadForm;